"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateWebhookDto = instanceOfUpdateWebhookDto;
exports.UpdateWebhookDtoFromJSON = UpdateWebhookDtoFromJSON;
exports.UpdateWebhookDtoFromJSONTyped = UpdateWebhookDtoFromJSONTyped;
exports.UpdateWebhookDtoToJSON = UpdateWebhookDtoToJSON;
exports.UpdateWebhookDtoToJSONTyped = UpdateWebhookDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateWebhookDto interface.
 */
function instanceOfUpdateWebhookDto(value) {
    return true;
}
function UpdateWebhookDtoFromJSON(json) {
    return UpdateWebhookDtoFromJSONTyped(json, false);
}
function UpdateWebhookDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'] == null ? undefined : json['url'],
        'events': json['events'] == null ? undefined : json['events'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}
function UpdateWebhookDtoToJSON(json) {
    return UpdateWebhookDtoToJSONTyped(json, false);
}
function UpdateWebhookDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'events': value['events'],
        'isActive': value['isActive'],
        'description': value['description'],
    };
}
